import { Injectable } from '@angular/core';
import { Category, Node, Rule } from '../models/types/Rule/Rule.type';

declare const dtrum: any;
declare const dynatrace: any;

enum EventProperty {
  ProductName = 'event_properties.ProductName',
  ProductSapCode = 'event_properties.ProductSapCode',
  CategoryName = 'event_properties.CategoryName',
  RuleName = 'event_properties.RuleName',
}

enum SessionProperty {
  StoreName = 'session_properties.StoreName',
  RoleName = 'session_properties.RoleName',
}

@Injectable({
  providedIn: 'root'
})
export class DynatraceService {

  private _eventPropertiesCache: { [key in EventProperty]?: string } = {};
  private _sessionPropertiesCache: { [key in SessionProperty]?: string } = {};
  private identifiedUser: string = '';

  constructor() { }

  //Invia un EventProperty a dynatrace
  protected sendEventProperty(properties: { [key in EventProperty]?: string }) {
    if (typeof dynatrace !== 'undefined') {
      dynatrace.sendEvent(properties);
      Object.keys(properties).forEach(key => {
        this.log(key, properties[key as EventProperty] || "");
      });
    }
  }

  //Invia una SessionProperty a dynatrace
  protected sendSessionPropertyEvent(properties: { [key in SessionProperty]?: string }) {
    if (typeof dynatrace !== 'undefined') {
      dynatrace.sendSessionPropertyEvent(properties);
      Object.keys(properties).forEach(key => {
        this.log(key, properties[key as SessionProperty] || "");
      });
    }
  }

  //Logga su dynatrace il nome dello store
  logStoreName(storeName: string, storeCode: string) {
    if (this._sessionPropertiesCache[SessionProperty.StoreName] === `${storeName} (${storeCode})`) {
      return;
    }
    this._sessionPropertiesCache[SessionProperty.StoreName] = `${storeName} (${storeCode})`;
    this.sendSessionPropertyEvent({
      [SessionProperty.StoreName]: `${storeName} (${storeCode})`
    });
  }

  //Logga su dynatrace il ruolo dell'utente
  logRoleName(roleName: string) {
    if (this._sessionPropertiesCache[SessionProperty.RoleName] === roleName) {
      return;
    }
    this._sessionPropertiesCache[SessionProperty.RoleName] = roleName;
    this.sendSessionPropertyEvent({
      [SessionProperty.RoleName]: roleName
    });
  }

  //Identifica l'utente su dynatrace tramite la sua email
  identifyUser(username: string) {
    if (this.identifiedUser === username) {
      return;
    }
    this.identifiedUser = username;
    if (dynatrace !== 'undefined') {
      dynatrace.identifyUser(username);
      this.log('identifyUser', username);
    }
  }

  //Logga la rule navigata (JEWELRY, HJ, ecc...)
  logRuleName(rule: Rule) {
    if (this._eventPropertiesCache[EventProperty.RuleName] === `${rule.name} (${rule.id})`) {
      return;
    }
    this._eventPropertiesCache[EventProperty.RuleName] = `${rule.name} (${rule.id})`;
    this.sendEventProperty({
      [EventProperty.RuleName]: `${rule.name} (${rule.id})`
    });
  }

  //Logga la categoria navigata (BZERO1, RINGS, ecc...)
  logCategoryName(category: Node) {
    if (this._eventPropertiesCache[EventProperty.CategoryName] === `${category.name} (${category.id})`) {
      return;
    }
    this._eventPropertiesCache[EventProperty.CategoryName] = `${category.name} (${category.id})`;
    this.sendEventProperty({
      [EventProperty.CategoryName]: `${category.name} (${category.id})`
    });
  }

  //Logga i dati del prodotto navigato
  logProduct(sapcode: string, name: string) {
    if (this._eventPropertiesCache[EventProperty.ProductSapCode] === sapcode &&
      this._eventPropertiesCache[EventProperty.ProductName] === name) {
      return;
    }
    this._eventPropertiesCache[EventProperty.ProductSapCode] = sapcode;
    this._eventPropertiesCache[EventProperty.ProductName] = name;
    this.sendEventProperty({
      [EventProperty.ProductSapCode]: sapcode,
      [EventProperty.ProductName]: name
    });
  }

  log(key: string, value: string) {
    console.log(`%c[Dynatrace]%c ${key} = %c${value}`,
      "color: black; font-weight: bold;",
      "color: gray; text-style: italic;",
      "color: black;")
  }

}
